<template>
  <Modal ref="modalRef" @after-close="resetForm">
    <template #body>
      <View direction="column" gap="md" padding-block="md" class="confirmation">
        <Text variant="h2" align="center">Please inform the applicants about the reason for canceling the showing</Text>

        <Text variant="body-large" color="secondary" align="center">
          The renters will be notified about your decision
        </Text>

        <Textarea class="cancel-reason-input" placeholder="Leave your feedback" rows="4" v-model="cancelReasonInput" />
      </View>
    </template>

    <template #footer>
      <Button variant="ghost" @click="close">Cancel</Button>
      <Button @click="cancelShowing" :loading="isLoading">Cancel showing</Button>
    </template>
  </Modal>
</template>

<script setup lang="ts">
import { ref } from 'vue';

import { Button, Modal, Textarea, View, Text, useAlertsStore } from '@tallo/design-system';

import { useCancelShowing } from '../mutations/cancel-showing.mutation';

const props = defineProps<{ showingId: string }>();

const alertStore = useAlertsStore();
const { mutateAsync, isLoading } = useCancelShowing();

const modalRef = ref<InstanceType<typeof Modal> | null>(null);
const cancelReasonInput = ref('');

function cancelShowing() {
  mutateAsync({
    showingId: props.showingId,
    cancelDto: {
      cancelReason: cancelReasonInput.value,
    },
  })
    .then(() => {
      close();
    })
    .catch((error) => {
      alertStore.catchError(error);
    });
}

function open() {
  modalRef.value?.show();
}

function close() {
  modalRef.value?.close();
}

function resetForm() {
  cancelReasonInput.value = '';
}

defineExpose({
  open,
  close,
});
</script>

<style scoped lang="scss">
.confirmation {
  max-width: 30rem;
}

.cancel-reason-input {
  width: 100%;
}
</style>
